import toggleMobileMenu from './header/toggle-mobile-menu'
import stickyNav from './header/sticky-nav'
import instantSearch from './algolia/instant-search'
import jobsSearch from './jobs-search/jobs-search'
import cardsHeight from './grids/cards/cards-height'
import enableVideo from './heroes/enable-video'
import salesPoints from './sales-points/sales-points'

/**
 * Atoms functions.
 */
export default function atoms() {
  toggleMobileMenu()
  stickyNav()
  instantSearch()
  jobsSearch()
  cardsHeight()
  enableVideo()
  salesPoints()
}
